module.exports = __webpack_public_path__ + "img/get-btn.4d51155a.png";